import { Stack } from 'expo-router';

// Route protection is handled at the root level; this layout only declares the stack.
// Titles are the browser/page chrome and must match each screen's own `title`.
export default function AuthLayout() {
    return (
        <Stack screenOptions={{ headerShown: false }} initialRouteName="login">
            <Stack.Screen name="login" options={{ title: 'Log In' }} />
            <Stack.Screen name="register" options={{ title: 'Sign Up' }} />
            <Stack.Screen name="verify-otp" options={{ title: 'Verify Email' }} />
            <Stack.Screen name="forgot-password" options={{ title: 'Forgot Password' }} />
            <Stack.Screen name="reset-password" options={{ title: 'Reset Password' }} />
        </Stack>
    );
}
